export enum SearchQualityCheckStatus {
  Empty = "Empty",
  Booked = "Booked",
  Approved = "Approved",
  ApprovedWithComment = "ApprovedWithComment",
  RequestSent = "RequestSent",
  RequestSentExpired = "RequestSentExpired",
  Expired = "Expired",
  ApprovedExpired = "ApprovedExpired",
  SigningPeriodExpired = "SigningPeriodExpired",
  RequestReceivedNotProcessed = "RequestReceivedNotProcessed",
  ConsultantResponsible = "ConsultantResponsible",
  Ordered = "Ordered",
  FullyApproved = "FullyApproved",
  OneApproved = "OneApproved",
  NotApproved = "NotApproved",
  RequestNotAnswered = "RequestNotAnswered",
  RequestExpired = "RequestExpired",
  AwaitingApproval = "AwaitingApproval",
  SentToRef = "SentToRef",
  ApprovedRef = "ApprovedRef",
  NotApprovedRef = "NotApprovedRef",
  Paused = "Paused"
}
